module.exports = __webpack_public_path__ + "19a8979011e77cfa32db086862c2a8af.png";